import React from 'react';
import {useTranslation} from 'react-i18next';
import TopCardElement from '../TopCardElement';
import DeliveryTypeSelector from '../../../Components/DeliverySelector/DeliveryTypeSelector/DeliveryTypeSelector';
import DeliveryAddressesSelector from '../../../Components/DeliverySelector/DeliveryAdressesSelector/DeliveryAddressesSelector';
import ChangeContactSelector from '../../../Components/CreateAndEditOrderComponents/ChangeContactSelector/ChangeContactSelector';
import CustomGreenCheckbox from '../../../Components/CustomCheckbox/CustomGreenCheckbox';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import s from '../Cart.module.css';

interface DeliverySectionProps {
	supplierId: number;
	values: {
		comment: string;
		approveCheckBox: boolean;
	};
	setFieldValue: (field: string, value: any) => void;
}

const DeliverySection: React.FC<DeliverySectionProps> = ({
	supplierId,
	values,
	setFieldValue,
}) => {
	const {t} = useTranslation();

	const handleCommentChange = (
		event: React.ChangeEvent<HTMLTextAreaElement>,
	) => {
		setFieldValue('comment', event.currentTarget.value);
	};

	return (
		<div className={s.methodContainer}>
			<TopCardElement title={t('Спосіб доставки')} number={'3'} />
			<DeliveryTypeSelector />

			<div className={s.addressContainer}>
				<TopCardElement title={t('Адреса доставки')} number={'4'} />
				<DeliveryAddressesSelector />
				
				<div className={s.changeAdresInfo}>
					{t('Виберіть контакт зі списку')}
				</div>
				
				<ChangeContactSelector supplier_id={supplierId} />
				
				<div className={s.commentTitle}>{t('Коментар до замовлення')}</div>
				
				<div className={s.addComment}>
					<textarea
						onChange={handleCommentChange}
						id="comment"
						placeholder={t('Введіть текст')}
						value={values.comment}
					/>
				</div>
				
				<div className={s.approveCheckBox}>
					<CustomGreenCheckbox
						setFieldValue={setFieldValue}
						name={'approveCheckBox'}
						labelTxt={t(
							'Я прочитав/прочитала і прийняв/прийняла повідомлення і текст згоди з Умовами та Політикою захисту даних',
						)}
						id={'approveCheckBox'}
						required={true}
						checked={values.approveCheckBox}
					/>
				</div>
				
				<div className={s.approveButtonWrapper}>
					<LightGreenButton
						text={t('Оформити замовлення')}
						type={'submit'}
					/>
				</div>
			</div>
		</div>
	);
};

export default DeliverySection;

